<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn v-if="hasRoleComprador"
             color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             link to="/fornecedores-gestao-grupos/cadastro">
        <v-icon left>mdi-plus</v-icon>
        Grupos de fornecedores
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por descrição ou fornecedor"
                      class="rounded-tag-small"
                      v-model="searchText"
                      style="max-width: 450px"
                      :on-search="emitChange"/>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
    searchText: {
      get() {
        return this.$store.getters['listagemFornecedoresGestaoGrupos/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemFornecedoresGestaoGrupos/searchText', searchText);
      },
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
  },
};
</script>
